/**
 * Given a base name and a list of existing names, returns the next available
 * clone name following the pattern: "X (Clone)", "X (Clone 2)", "X (Clone 3)", etc.
 *
 * Comparison is case-insensitive to avoid near-duplicate names.
 */
export const getNextCloneName = (baseName, existingNames) => {
    const lowerNames = new Set(existingNames.map((n) => n.toLowerCase()));
    const firstCandidate = `${baseName} (Clone)`;
    if (!lowerNames.has(firstCandidate.toLowerCase())) {
        return firstCandidate;
    }
    let counter = 2;
    // Safety upper bound to avoid infinite loop
    while (counter < 1000) {
        const candidate = `${baseName} (Clone ${counter})`;
        if (!lowerNames.has(candidate.toLowerCase())) {
            return candidate;
        }
        counter++;
    }
    return `${baseName} (Clone ${Date.now()})`;
};
